var React = require('react');

function IconFactory (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.5,4.2v21.1l-4.2,2.4l2.1,3.6l27.1-15.7v9.6l-4.2,2.5l2.2,3.6l27.1-15.7v46.9H4.2V4.2H12.5 M16.7,0H0v66.7h66.7V8.3\n\tl-25,14.6V8.3l-25,14.6V0z M20.8,41.7h-8.3V50h8.3V41.7z M37.5,41.7h-8.3V50h8.3V41.7z M54.2,41.7h-8.3V50h8.3V41.7z"}));
}

IconFactory.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 66.7 66.7","enableBackground":"new 0 0 66.7 66.7","xmlSpace":"preserve"};

module.exports = IconFactory;

IconFactory.default = IconFactory;
